/*
 * Author: Harper Yan
 * File Created: Friday, 24-07-12 09:11 am
 * Last Modified: Friday, 24-08-30 09:38 pm, by Dw
 */

import { snackbarContentClasses } from '@mui/material';
import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material/styles';

type SnackbarThemeOptions = {
  defaultProps?: ComponentsProps['MuiSnackbar'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiSnackbar'];
  variants?: ComponentsVariants<Theme>['MuiSnackbar'];
};

export const MuiSnackbar: SnackbarThemeOptions = {
  defaultProps: {
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'center',
    },
    autoHideDuration: 1500,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      [`.${snackbarContentClasses.root}`]: {
        background: 'rgba(27, 30, 39, 0.95)',
        borderRadius: '8px',
        color: '#FFF',
        fontSize: '12px',
        fontWeight: 400,
        minWidth: 'auto',
        maxWidth: '280px',
      },
    }),
    anchorOriginTopCenter: ({ theme }) => ({
      [theme.breakpoints.up('xs')]: {
        top: '50%',
        left: '50%',
        right: 'auto',
        transform: 'translateX(-50%)',
      },
    }),
  },
};
